module.exports = __webpack_public_path__ + "static/media/coinbase.2f48ef91.jpg";